export const doublerContractSource = `
  pragma solidity ^0.8.0;

  contract DoublerContract {
    function double(int num) public view returns (int) {
      return 2 * num;
    }
  }
`

export const doublerContractABI = {
  contractName: 'Doubler',
  abi: [
    {
      inputs: [
        {
          internalType: 'int256',
          name: 'num',
          type: 'int256',
        },
      ],
      name: 'double',
      outputs: [
        {
          internalType: 'int256',
          name: '',
          type: 'int256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
  ],
  // eslint-disable-next-line max-len
  bytecode:
    '0x608060405234801561001057600080fd5b50610284806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c80636ffa1caa14610030575b600080fd5b61004a6004803603810190610045919061008b565b610060565b60405161005791906100c7565b60405180910390f35b600081600261006f91906100e2565b9050919050565b60008135905061008581610237565b92915050565b6000602082840312156100a1576100a0610232565b5b60006100af84828501610076565b91505092915050565b6100c1816101f9565b82525050565b60006020820190506100dc60008301846100b8565b92915050565b60006100ed826101f9565b91506100f8836101f9565b9250827f7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff048211600084136000841316161561013757610136610203565b5b817f8000000000000000000000000000000000000000000000000000000000000000058312600084126000841316161561017457610173610203565b5b827f800000000000000000000000000000000000000000000000000000000000000005821260008413600084121616156101b1576101b0610203565b5b827f7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff05821260008412600084121616156101ee576101ed610203565b5b828202905092915050565b6000819050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b600080fd5b610240816101f9565b811461024b57600080fd5b5056fea2646970667358221220e0f1b965a34ad318359f3807e21004e1f1e04c1b7e14d098a5dc4ea5a72dac6b64736f6c63430008070033',
}
